import React, { Component } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './ScrollToTop';

import Home from './main/Home';
import Privacy from './privacy/Privacy'
import Contact from './contact/Contact'
import Service from './service/Service'
import Account from './service/Account'
import DeferredLanding from './main/DeferredLanding';

class App extends Component {
  render() {
    return (
      <HashRouter>
        <ScrollToTop />
        <Routes>
          <Route path='/'     element={<Home/>}/>
          <Route path='/privacy' element={<Privacy/>}/>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/service' element={<Service/>}/>
          <Route path='/account' element={<Account/>}/>
          <Route path='/link' element={<DeferredLanding/>}/>
        </Routes>
      </HashRouter>
    );
  }
}

export default App;